module.exports = __webpack_public_path__ + "img/sleeve lower flounce opening.9d8a7a79.png";